module.exports = __webpack_public_path__ + "static/img/icon_pd_info.0a42016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon_pd_info.png
// module id = m8lG
// module chunks = 1